 
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import message from '@/components/message.vue';
	import {
		nextDay,
		getSearchDate
	} from "@/utils"
  import {
    orderSettlesettleFirstinfo,
    orderSettlesettleFirst,
    orderSettlesettleLastinfo,
    orderSettlesettleLast,
    orderSettledetailexportparamCache,


    orderSettlesettleInfo,
    financeorderSettlesettle,
    orderSettlesettleTime
  } from "@/api/order"
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-message': message,
    }
  })

  export default class ProductList extends Vue {
    private pageloading = false
    private form:any = {}
		private defaultThumb = 'https://cdn2024.shiwuzone.com/routuanapp/default-thumb.png';
    private messageShow = false
    private messageloading = false
    private type = 1//1计算//2提交
    private disabled = Number(this.$route.query.FinanceOrderSettleRecordId)>0
    private listName = ''
    private finishShow = false

    private mounted () {
      this.getinfo()
    }

    private simplifytime(time){
      if(time){
        return time.substring(0,10)
      }else{
        return ''
      }
    }
    private toODdetail(row,type,time){
      this.$router.push({
        path:'orderDetails',
        query:{
          FinanceOrderSettleOrderDetailFromPageType:type,
          FinanceOrderSettleRecordId:this.form.FinanceOrderSettleRecordId,
          ProductId:row.ProductId,
          SpecValue:row.SpecValue,
          StartTime:time.StartTime,
          EndTime:nextDay(time.EndTime,1),
        }
      })
    }
    private toAFdetail(row,time){
      this.$router.push({
        path:'aftersaleDetails',
        query:{
          FinanceOrderSettleRecordId:this.form.FinanceOrderSettleRecordId,
          StartTime:time.StartTime,
          EndTime:nextDay(time.EndTime,1)
        }
      })
    }
    private tabSpan({ row, column, rowIndex, columnIndex }){
      if(columnIndex==3){
        return [5,1]
      }
    }
    private exportfile(){
      let url = location.origin
      url += '/provider/finance/orderSettle/detail/export'
      url += '?FinanceOrderSettleRecordId=' + (this.form.FinanceOrderSettleRecordId||'')
      url += '&StartTime=' + this.$route.query.StartTime,
      url += '&EndTime=' + this.$route.query.EndTime,
      window.open(url)
    }
    private torules(row){
      this.$router.push({
        name:'settleTemplatedetail',
        query:{
          Type:'1',
          ProductId:row.ProductId
        }
      })
    }
    private copy(e){
      let text = `开户人：${this.form.CardHolder}\n`
      text += `开户银行：${this.form.BankName}\n`
      text += `开户行：${this.form.SubbranchName}\n`
      text += `账号：${this.form.BankCardNumber}\n`
      handleClipboard(text,e)
    }
    private async toSettle(type){
      try{
        if(!this.form.PreLastSettleInfo&&!this.form.PreFirstSettleInfo&&!this.form.FirstSettleInfo&&!this.form.SupportSettleInfo){
          this.$message.error('操作失败，无待结算数据')
          return
        }
        // if(this.form.FirstSettleInfo&&this.form.FirstSettleInfo.FirstSettleProductInfoList){
        //   for(let item of this.form.FirstSettleInfo.FirstSettleProductInfoList){
        //     if(item.RouTuanPrice==0){
        //       this.$message.error('请完善供货价后再发起结算')
        //       return 
        //     }
        //   }
        // }
        this.type = 2
        this.messageShow = true
        this.messageloading = false
        let form = JSON.parse(JSON.stringify(this.form))
        if(!form.FirstSettleInfo.FirstSettleProductInfoList||!form.FirstSettleInfo.FirstSettleProductInfoList.length){
          form.FirstSettleInfo.FirstSettleProductInfoList = []
        }
        let res = await financeorderSettlesettle({
          SettleInfo:{
            ...form,
            FirstSettleInfo:{
              ...form.FirstSettleInfo,
              FirstSettleProductInfoList:form.FirstSettleInfo.FirstSettleProductInfoList.map(v=>{
                v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*100).toFixed(0))/10000
                return v
              })
            }
          },
          ...this.$route.query
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.messageShow = false
          this.finishShow = true
          // this.$router.go(-1)
        }
      }finally{
        setTimeout(()=>{
          this.messageShow = false
        },2000)
      }
    }
    private async blurSettle(row,num){
      this.type = 1
      if(num<1||num>100||num!=parseInt(num)){
        this.$message.error('请输入1-100的数值')
        return
      }
      try{
        this.messageShow = true
        this.messageloading = false
        let res:any
        let form = JSON.parse(JSON.stringify(this.form))
        let data:any = {
          ...form,
          FirstSettleInfo:{
            ...form.FirstSettleInfo,
            FirstSettleProductInfoList:form.FirstSettleInfo?.FirstSettleProductInfoList.map(v=>{
              v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*100).toFixed(0))/10000
              return v
            })
          },
        }
        res = await orderSettlesettleInfo({
          FinanceOrderSettleRecordId:this.$route.query.FinanceOrderSettleRecordId,
          SettleInfo:data,
          ...this.$route.query
        })
        if(res.IsSuccess){
          let form2 = res.Result
          form2.FinanceOrderSettleRecordId = this.$route.query.FinanceOrderSettleRecordId,
          form2.FirstSettleInfo.FirstSettleProductInfoList = form2.FirstSettleInfo?.FirstSettleProductInfoList.map(v=>{
            v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*10000).toFixed())/100
            return v
          })
          let restime = await orderSettlesettleTime({})
          if(!form2.PreLastSettleInfo){
            form2.PreLastSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate||'',
              SubmitOrderEndDate:restime.Result.PreSettleEndDate||'',
              ActualSettleAllMoney:0,
            }
          }
          if(!form2.PreFirstSettleInfo){
            form2.PreFirstSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate||'',
              SubmitOrderEndDate:restime.Result.PreSettleEndDate||'',
              ActualSettleAllMoney:0,
            }
          }
          form2.accountlist = this.getaccountlist(form2)
          this.form = form2
        }
      }finally{
        setTimeout(()=>{
          this.messageShow = false
        },2000)
      }
    }
    private async getinfo(){
      try{
        this.pageloading = true
        let res = await orderSettlesettleInfo({...this.$route.query})
        if(res.IsSuccess){
          let form = res.Result
          form.FinanceOrderSettleRecordId = this.$route.query.FinanceOrderSettleRecordId
          if(form.FirstSettleInfo?.FirstSettleProductInfoList&&form.FirstSettleInfo?.FirstSettleProductInfoList.length){
            form.FirstSettleInfo.FirstSettleProductInfoList = form.FirstSettleInfo.FirstSettleProductInfoList.map(v=>{
              v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*10000).toFixed())/100
              return v
            })
          }
          let restime = await orderSettlesettleTime({})
          if(!form.PreLastSettleInfo){
            form.PreLastSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate||'',
              SubmitOrderEndDate:restime.Result.PreSettleEndDate||'',
              ActualSettleAllMoney:0,
            }
          }
          if(!form.PreFirstSettleInfo){
            form.PreFirstSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate||'',
              SubmitOrderEndDate:restime.Result.PreSettleEndDate||'',
              ActualSettleAllMoney:0,
            }
          }
          if(!form.FirstSettleInfo){
            form.FirstSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate||'',
              SubmitOrderEndDate:restime.Result.PreSettleEndDate||'',
              ActualSettleAllMoney:0,
            }
          }
          form.accountlist = this.getaccountlist(form)
          this.form = form
        }
      }finally{
        this.pageloading = false
      }
    }
    private change(){
      this.$router.push({
        path:'account',
      })
    }
    
    private getaccountlist(form){
      let accountlist = []
      accountlist = [
        form.PreFinanceOrderSettleRecordId?{
          name:`上次对账单（${this.simplifytime(form.PreLastSettleInfo.SubmitOrderStartDate)}至${this.simplifytime(form.PreLastSettleInfo.SubmitOrderEndDate)}）的尾款`,
          money:form.PreLastSettleInfo.ActualSettleAllMoney,
          type:1,
        }:undefined,
        form.PreFinanceOrderSettleRecordId?{
          name:`上次对账单（${this.simplifytime(form.PreFirstSettleInfo.SubmitOrderStartDate)}至${this.simplifytime(form.PreFirstSettleInfo.SubmitOrderEndDate)}）剩余新签收的订单全款`,
          money:form.PreFirstSettleInfo.ActualSettleAllMoney,
          type:2,
        }:undefined,
        form.PreFinanceOrderSettleRecordId?{
          name:'本次结算日期下的所有订单首款/全款 (期间有开团产品为首款，则为全款)',
          money:form.FirstSettleInfo.ActualSettleAllMoney,
          type:3,
        }:{
          name:`${this.simplifytime(form.SubmitOrderStartDate)}至${this.simplifytime(form.SubmitOrderEndDate)}已签收的订单首款`,
          money:form.FirstSettleInfo.ActualSettleAllMoney,
          type:3,
        },
        {
          name:'期间完结的售后',
          money:form.SupportSettleInfo?.SupportSettleProductInfoList.reduce((acc,val)=>{
            let allacc = acc
            allacc+=val.RefundProductMoney
            allacc+=val.SupportSubsidyMoney
            allacc+=val.SupportReturnFreightInsuranceMoney
            return +(allacc).toFixed(2)
          },0)||0,
          type:4,
        },
        form.ProviderContractType==1?{
          name:'服务费税额',
          money:form.TaxFee,
          tip:`（说明：服务费${form.ServiceFee>0?form.ServiceFee:0}）`,
          tip1: `<div>此次平台收取的服务费金额${form.ServiceFee>0?form.ServiceFee:0}</div>商家在平台上实现的含税销售收入为${+(form.RoutuanSellIncome-form.SupportRealRefundAllMoney).toFixed(2)}，商家须以此金额为依据，及时足额申报纳税。`,
          type:5,
          ServiceFee:form.ServiceFee
        }:undefined,
      ].filter(v=>v).map(v=>{
        if(v.type==4){
          v.money = (v.money==0?'':'-')+v.money
        }
        return v
      })
      return accountlist
    }
  }
